import React, { useState, useEffect } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import * as axios from "axios";
import * as urls from "../constants/webapi/postalcodeCity";
import { RegexFields } from "../constants/utils/regexFields";
import * as R from "ramda";

export const PostalCityInput = ({
	postalCode,
	city,
	onChange,
	postalCodePattern = RegexFields.frenchZipCode,
	cityPattern = "^[a-zA-ZáàâãçéèêëîïíìòóõôûùúüÿñæœßÁÀÂÃÇÉÈÊËÎÏÍÌÓÒÕÔÛÙÚÜŸÑÆŒẞºª'\\s.,\\-0-9]+$",
	customClasses = {},
	postalCodeId = "PostalCodeInput",
	cityId = "CityInput",
	postalCodeRequired = true,
	cityRequired = true,
	postalCodeDisabled = false,
	cityDisabled = false,
	hasWrapper = true,
	wrapperClass = "",
	country,
}) => {
	const [selectedCityOption, setSelectedCityOption] = useState(city || postalCode ? {
		label: city,
		value: city,
		postalCode: postalCode,
	} : null);
	const [cityOptions, setCityOptions] = useState([]);
	const [cityMenuIsOpen, setCityMenuIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [_postalCode, setPostalCode] = useState(postalCode);
	const [_city, setCity] = useState(city);

	const [isCityInvalid, setIsCityInvalid] = useState(false);

	const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop("label")));

	useEffect(() => {
		if (_city === "" && (country === "FR" || country === "France")) {
			setSelectedCityOption(null);
			// setPostalCode(undefined);
		}
		if (_postalCode?.length === 5 || (country !== "FR" && country !== "France")) {
			setCityMenuIsOpen(true);
			if (!selectedCityOption) {
				setCity("");
			}
			async function loadAndSetCities() {
				const searchResult = await loadCities(_postalCode);
				setCityOptions(searchResult.options);
			}
			loadAndSetCities();
		} else {
			setCityOptions([{ label: "Ajout manuel", postalCode: _postalCode, value: _city || " " }]);
		}

		if (_city !== "" && (_postalCode?.length === 5 || (country !== "FR" && country !== "France")) && !selectedCityOption) {
			setSelectedCityOption({
				label: _city,
				value: _city,
				postalCode: _postalCode,
			});
		}
	}, [_city, _postalCode, selectedCityOption]);

	useEffect(() => {
		if (postalCode && (_postalCode === "" || !_postalCode)) {
			setPostalCode(postalCode);

			if (postalCode?.length === 5 || (country !== "FR" && country !== "France")) {
				setCityMenuIsOpen(true);
				if (!selectedCityOption) {
					setCity("");
				}
				async function loadAndSetCities() {
					const searchResult = await loadCities(postalCode);
					setCityOptions(searchResult.options);
				}
				loadAndSetCities();
			} else {
				setCityOptions([{ label: "Ajout manuel", postalCode: _postalCode, value: _city || " " }]);
			}
		}
		if (city && _city === "") {
			setCity(city);
		}

		if (city !== "" && (_postalCode?.length === 5 || (country !== "FR" && country !== "France")) && !selectedCityOption) {
			setSelectedCityOption({
				label: city,
				value: city,
				postalCode: postalCode,
			});
		}
	}, [city, postalCode]);

	useEffect(() => {
		if (country && (country !== "FR" && country !== "France")) {
			setSelectedCityOption({
				label: _city,
				value: _city,
				postalCode: _postalCode,
			});
			onChange({ postalCode: _postalCode, city: _city });
			return;
		}
	}, [country]);

	const loadCities = async (search) => {
		if (!search) return { options: [], hasMore: false };
		try {
			setIsLoading(true);
			const response = await axios.get(urls.searchCityOrPostalCode(search));
			let result = [];
			response.data.forEach((el) => {
				const exists = result.find((x) => x.Name === el.Name && x.PostalCode === el.PostalCode);
				if (!exists) {
					result.push(el);
				}
			});

			const unorderedOptions = result.map((d) => ({
				label: `${d.Name} (${d.PostalCode})`,
				value: d.Name,
				postalCode: d.PostalCode,
			}));
			const sortedOptions = sortByNameCaseInsensitive(unorderedOptions);
			sortedOptions.push({ label: "Ajout manuel", postalCode: _postalCode, value: _city || ' ' });
			setIsLoading(false);
			return { options: sortedOptions, hasMore: false };
		} catch (error) {
			setIsLoading(false);
			console.error("Error loading cities:", error);
			return { options: [], hasMore: false };
		}
	};
	const updateCityValidityState = (isInvalid) => {
		setIsCityInvalid(isInvalid);
	};

	const InputFields = (
		<>
			{country === "FR" || country === "France" ? (
				<>
					<div className={`form-group col ${customClasses.postalCode || ""}`}>
						<label className="h6 font-weight-bolder my-auto" htmlFor={postalCodeId}>
							Code Postal *
						</label>
						{country === null || country === "FR" || country === "GF" || country === "PF" || country === "TF" ? (
							<input
								required={postalCodeRequired}
								disabled={postalCodeDisabled}
								placeholder="ex: 75001"
								type="text"
								className="form-control"
								id={postalCodeId}
								value={_postalCode}
								onChange={(e) => {
									setPostalCode(e.target.value);
									onChange({ postalCode: e.target.value, city: _city });
									if (e.target.value.length !== 5) {
										setSelectedCityOption(null);
									} else {
										setCityMenuIsOpen(true);
									}
								}}
								pattern={postalCodePattern}
							/>
						) : (
							<input
								placeholder="ex: 75001"
								required={postalCodeRequired}
								disabled={postalCodeDisabled}
								type="text"
								className="form-control"
								id={postalCodeId}
								value={_postalCode}
								onChange={(e) => {
									setPostalCode(e.target.value);
									onChange({ postalCode: e.target.value, city: _city });
								}}
							/>
						)}
						<div className="invalid-feedback">
							<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
							<span className="align-middle text-dark o-70">{_postalCode ? "Le format n'est pas correct" : "Ce champ est requis"}</span>
						</div>
					</div>

					<div className={`form-group col ${customClasses.city || ""}`}>
						<label className="h6 font-weight-bolder my-auto" htmlFor={cityId}>
							Ville *
						</label>
						{R.isNil(selectedCityOption) && (
							<AsyncPaginate
								key={cityOptions.length || "default"}
								id={cityId}
								className={isCityInvalid ? "form-control form-select custom-input is-invalid" : "form-control form-select"}
								required={cityRequired}
								disabled={cityDisabled}
								loadOptions={loadCities}
								options={cityOptions}
								value={selectedCityOption}
								onChange={(option) => {
									setPostalCode(option.postalCode || _postalCode);
									setCity(option.value);
									onChange({ postalCode: option.postalCode || _postalCode, city: option.value });
									setSelectedCityOption({ postalCode: option.postalCode || _postalCode, city: option.value });
									setCityMenuIsOpen(false);
								}}
								onInputChange={(searchInput) => {
									if (searchInput && searchInput !== "") {
										setCity(searchInput);
										onChange({ postalCode: _postalCode, city: searchInput });
									}
								}}
								debounceTimeout={1000}
								placeholder="ex: Paris"
								loadingMessage={() => "Chargement..."}
								noOptionsMessage={() => "Aucun résultat"}
								loading={isLoading}
								onMenuOpen={() => setCityMenuIsOpen(true)}
								onMenuClose={() => setCityMenuIsOpen(false)}
								menuIsOpen={cityMenuIsOpen}
								loadOptionsOnMenuOpen={false}
								styles={{
									menu: (provided) => ({
										...provided,
										zIndex: 4,
									}),
								}}
							/>
						)}
						<input
							placeholder="ex: Paris"
							disabled={cityDisabled}
							required={cityRequired}
							type="text"
							className={R.isNil(selectedCityOption) ? "invisible position-absolute" : "form-control"}
							id="Ville"
							value={_city}
							pattern={cityPattern}
							onInput={(e) => {
								e.preventDefault();
								setCity(e.target.value);
								onChange({ postalCode: _postalCode, city: e.target.value });
							}}
						/>
						<div className="invalid-feedback">
							<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
							<span className="align-middle text-dark o-70">Ce champ est requis</span>
						</div>
					</div>
				</>
			) : (
				<>
					<div className={`form-group col ${customClasses.postalCode || ""}`}>
						<label className="h6 font-weight-bolder my-auto" htmlFor={postalCodeId}>
							Code Postal
						</label>
						<input
							placeholder="ex: 75001"
							disabled={postalCodeDisabled}
							type="text"
							className="form-control"
							id={postalCodeId}
							value={_postalCode}
							onChange={(e) => {
								setPostalCode(e.target.value);
								onChange({ postalCode: e.target.value, city: _city });
							}}
						/>
						<div className="invalid-feedback">
							<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
							<span className="align-middle text-dark o-70">Ce champ est requis</span>
						</div>
					</div>

					<div className={`form-group col ${customClasses.city || ""}`}>
						<label className="h6 font-weight-bolder my-auto" htmlFor={cityId}>
							Ville
						</label>

						<input
							placeholder="ex: Paris"
							disabled={cityDisabled}
							type="text"
							className={"form-control"}
							id="Ville"
							value={_city}
							pattern={cityPattern}
							onInput={(e) => {
								e.preventDefault();
								setCity(e.target.value);
								onChange({ postalCode: _postalCode, city: e.target.value });
							}}
						/>
						<div className="invalid-feedback">
							<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
							<span className="align-middle text-dark o-70">Ce champ est requis</span>
						</div>
					</div>
				</>
			)}
		</>
	);

	return hasWrapper ? <div className={`row gx-1 ${wrapperClass}`}>{InputFields}</div> : InputFields;
};
